import { default as schemaUri } from '../__generated__/schema.all.min.graphql';

let fetchPromise: Promise<Response>;
let types: Promise<string>;

export async function loadTypes(): Promise<string> {
    if (!process.env.JEST_WORKER_ID) {
        try {
            if (!fetchPromise) {
                fetchPromise = fetch(schemaUri);
            }

            const response = await fetchPromise;
            if (!types) {
                types = response.text();
            }

            return types;
        } catch (e) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (23,13): Type 'undefined' is not assignable to type 'Promise<Response>'.
            // @ts-expect-error
            fetchPromise = undefined;
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (27,13): Type 'undefined' is not assignable to type 'Promise<string>'.
            // @ts-expect-error
            types = undefined;
            throw e;
        }
    } else {
        // In tests, the "schemaUri" is transformed to just be the source
        return schemaUri;
    }
}

export function loadTypesForTests(): string {
    return schemaUri;
}
